import React, { useState } from 'react';
import { CALL_API, successResponse, notSuccessResponse } from '../../../util/api'

export const getListOfValue = async (param) => {

    try {
        const response = await CALL_API.post('ListOfValue/Search', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

//export const getListOfValueLookup = async (param) => {

//    try {
//        const response = await CALL_API.post('ListOfValue/lookup/Type', param);
//        return successResponse(response);
//    } catch (error) {
//        return notSuccessResponse(error);
//    }

//}

export const getListOfValueType = async () => {

    try {
        const response = await CALL_API.post('ListOfValue/GetType');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const updateListOfValue = async (param) => {

    try {
        const response = await CALL_API.post('ListOfValue/Update', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const insertListOfValue = async (param) => {

    try {
        const response = await CALL_API.post('ListOfValue/Insert', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getListOfValueByType = async (param) => {

    try {
        const response = await CALL_API.post('ListOfValue/ByType', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
